(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function linkProductImages(root) {
      root.querySelectorAll('.og-card-wrap[data-product-url]').forEach(function (card) {
        var url = card.getAttribute('data-product-url');
        if (!url) return;

        // Find the media/image element inside the product card block
        var media = card.querySelector(
          '[class*="product-card"] [class*="media"], ' +
          '[class*="product-card"] [class*="gallery"], ' +
          '[class*="product-card"] img, ' +
          '[class*="card"] [class*="media"]'
        );
        if (!media) return;

        // Don't wrap if already inside an anchor
        if (media.closest('a[href]')) return;

        var wrap = document.createElement('a');
        wrap.href = url;
        wrap.setAttribute('aria-hidden', 'true');
        wrap.setAttribute('tabindex', '-1');
        wrap.className = 'og-image-link';

        media.parentNode.insertBefore(wrap, media);
        wrap.appendChild(media);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { linkProductImages(document); });
    } else {
      linkProductImages(document);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var phoneMediaQuery = window.matchMedia('(max-width: 749px)');

    function setPhoneMode(section) {
      if (!section) return;
      section.setAttribute('data-is-phone', phoneMediaQuery.matches ? 'true' : 'false');
    }

    function updateAllPhoneModes() {
      document.querySelectorAll('.slideshow-section').forEach(setPhoneMode);
    }

    // Make slide images clickable via their first button/link URL
    function linkSlideImages(section) {
      section.querySelectorAll('slideshow-slide').forEach(function (slide) {
        var btn = slide.querySelector('a[href]:not([href="#"]):not([href=""])');
        if (!btn) return;
        var href = btn.getAttribute('href');
        var target = btn.getAttribute('target') || '_self';
        var media = slide.querySelector(
          '.slide__media, slideshow-media, .slideshow__media, [class*="slide"][class*="media"], img, video'
        );
        if (!media || media.closest('a')) return;
        var wrap = document.createElement('a');
        wrap.href = href;
        wrap.target = target;
        wrap.setAttribute('aria-hidden', 'true');
        wrap.setAttribute('tabindex', '-1');
        wrap.style.cssText = 'display:contents;cursor:pointer;';
        media.parentNode.insertBefore(wrap, media);
        wrap.appendChild(media);
      });
    }

    function init() {
      updateAllPhoneModes();
      document.querySelectorAll('slideshow-component').forEach(linkSlideImages);

      if (typeof phoneMediaQuery.addEventListener === 'function') {
        phoneMediaQuery.addEventListener('change', updateAllPhoneModes);
      } else if (typeof phoneMediaQuery.addListener === 'function') {
        phoneMediaQuery.addListener(updateAllPhoneModes);
      }

      window.addEventListener('resize', updateAllPhoneModes, { passive: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
